import React from 'react';
import HometapLogo from 'assets/images/logo-hometap.svg';

// use this data structure to make changes/edits to copy (this will affect mobile "columns" and desktop rows)
const rowLabels = {
  qualifications: {
    creditScore: 'Average credit score',
    loanToValue: 'Average loan-to-value',
    debtToIncome: 'Average debt-to-income',
    otherRestrictions: 'Other restrictions (vary by lender)',
  },
  pricing: {
    investment: 'Investment/loan amount',
    term: 'Term',
    loan: 'Loan',
    interestType: 'Interest rate type',
    averageInterestRate: 'Average interest rate',
    monthlyPayment: 'Monthly payment',
    costs: 'Costs & fees',
    dueAtSettlement: 'Due at settlement, sale, or refinancing',
  },
};

export const DEFAULT_COLUMNS = [
  { label: '', key: 'row', width: '20%' },
  {
    label: <img style={{ width: '90%' }} src={HometapLogo} alt="Hometap logo" />,
    width: '16.6666%',
    key: 'hometap',
  },
  { label: 'Home equity loan', key: 'homeEquityLoan', width: '16.6666%' },
  { label: 'HELOC', key: 'heloc', width: '16.6666%' },
  { label: 'Cash-out refinance', key: 'cashOut', width: '16.6666%' },
  { label: 'Reverse mortgage', key: 'reverseMortgage', width: '16.6666%' },
];

const { pricing, qualifications } = rowLabels;

export const MOBILE_COLUMNS = Object.keys(rowLabels).reduce((acc, key) => {
  const rowLabelData = rowLabels[key];
  return {
    ...acc,
    [key]: [
      {
        label: '',
        key: 'row',
      },
      ...Object.keys(rowLabels[key]).map((rowKey) => ({
        label: rowLabelData[rowKey],
        key: rowKey,
      })),
    ],
  };
}, {});

export const COMPARISON_TABLE_DATA = {
  pricing: [
    {
      id: 1,
      row: pricing.investment,
      hometap: '$100,000',
      homeEquityLoan: '$100,000',
      heloc: '$100,000',
      cashOut: '$100,000',
      reverseMortgage: '$100,000',
    },
    {
      id: 2,
      row: pricing.term,
      hometap: '10 years',
      homeEquityLoan: '10 years',
      heloc: '10 years',
      cashOut: '10 years',
      reverseMortgage: 'Loan repaid when borrower passes away or sells home',
    },
    {
      id: 3,
      row: pricing.loan,
      hometap: 'No',
      homeEquityLoan: 'Yes',
      heloc: 'Yes',
      cashOut: 'Yes',
      reverseMortgage: 'Yes',
    },
    {
      id: 4,
      row: pricing.interestType,
      hometap: 'None',
      homeEquityLoan: 'Fixed or variable',
      heloc: 'Typically Variable',
      cashOut: 'Fixed or variable',
      reverseMortgage: 'Fixed or variable',
    },
    {
      id: 5,
      row: pricing.averageInterestRate,
      hometap: 'No interest',
      homeEquityLoan: '7.09%',
      heloc: '6.04%',
      cashOut: '4.7%',
      reverseMortgage: '3.68%',
    },
    {
      id: 6,
      row: pricing.monthlyPayment,
      hometap: 'None',
      homeEquityLoan: '$1,165',
      heloc: '$1,112',
      cashOut: '$1,050',
      reverseMortgage: 'None',
    },
    {
      id: 7,
      row: pricing.costs,
      hometap: '3% of investment + signing costs',
      homeEquityLoan: '3-5% of the loan amount',
      heloc: '$100 in annual fees',
      cashOut: '2-5% of loan amount',
      reverseMortgage: 'Origination fee up to $6,000 + 2% MIP fee + monthly option fee up to $35',
    },
    {
      id: 8,
      row: pricing.dueAtSettlement,
      hometap: '13.9-16.7% of home value (dependent on appraised home value at settlement)',
      homeEquityLoan: 'Outstanding principal',
      heloc: 'Outstanding principal',
      cashOut: 'Outstanding principal',
      reverseMortgage: 'Outstanding principal + interest + mortgage insurance',
    },
  ],
  qualifications: [
    {
      id: 1,
      row: qualifications.creditScore,
      hometap: 'Typically over 630 (no firm requirement)',
      homeEquityLoan: 'Min score of 620',
      heloc: 'Min score of 620',
      cashOut: 'Min score of 620',
      reverseMortgage: 'No firm requirement',
    },
    {
      id: 2,
      row: qualifications.loanToValue,
      hometap: 'Max LTV of 75%',
      homeEquityLoan: 'Max LTV of 80-85%',
      heloc: 'Max LTV of 80-85%',
      cashOut: 'Max LTV of 80%',
      reverseMortgage: 'Max LTV of 50%-65%',
    },
    {
      id: 3,
      row: qualifications.debtToIncome,
      hometap: 'N/A',
      homeEquityLoan: '43%',
      heloc: '43%',
      cashOut: '50%',
      reverseMortgage: 'N/A',
    },
    {
      id: 4,
      row: qualifications.otherRestrictions,
      hometap: 'No prepayment penalties',
      homeEquityLoan: 'Prepayment penalties	',
      heloc: 'Minimum annual draw requirements, prepayment penalties + cancellation fees occur with some lenders',
      cashOut: 'Prepayment penalties + cancellation fees',
      reverseMortgage: 'Must be 62+ years old, must own home outright or have single primary lien',
    },
  ],
};
